import React from "react";
import { Helmet } from "react-helmet";
import data from "../data/terms.json";
export default function AdhanTerm() {
  const terms = data.data;
  return (
    <>
      <Helmet>
        <title>Adhan : Terms &amp; Conditions</title>
      </Helmet>
      <div className="max-w-[1200px] mx-auto pt-20">
        <h1 className="text-3xl font-bold">Adhan Terms &amp; Conditions</h1>
        <p>
          Adhan is licensed to You (End-User) by Haaris Iqubal, located at D 186
          Okhla, New Delhi, Delhi 110025, India (hereinafter: Licensor), for use
          only under the terms of this License Agreement. By downloading the
          Application from the Apple AppStore, and any update thereto (as
          permitted by this License Agreement), You indicate that You agree to
          be bound by all of the terms and conditions of this License Agreement,
          and that You accept this License Agreement. The parties of this
          License Agreement acknowledge that Apple is not a Party to this
          License Agreement and is not bound by any provisions or obligations
          with regard to the Application, such as warranty, liability,
          maintenance and support thereof. Haaris Iqubal, not Apple, is solely
          responsible for the licensed Application and the content thereof. This
          License Agreement may not provide for usage rules for the Application
          that are in conflict with the latest{" "}
          <a
            className="text-blue-500"
            href="https://www.apple.com/legal/internet-services/itunes/us/terms.html"
          >
            App Store Terms of Service
          </a>
          . Haaris Iqubal acknowledges that it had the opportunity to review
          said terms and this License Agreement is not conflicting with them.
          All rights not expressly granted to You are reserved.
        </p>
        {terms.map((item) => (
          <>
            <a
              className="block text-blue-500"
              key={item.id}
              href={`/adhan/privacy#${item.title.toLowerCase().replace(/[^a-z]/g, "")}`}
            >
              {item.id}.{item.title}
            </a>
          </>
        ))}
        {terms.map((item) => (
          <div id="py-4">
            <h3
              id={`${item.title.toLowerCase().replace(/[^a-z]/g, "")}`}
              className="font-bold text-xl pb-2"
              key={item.id}
            >
              {item.id}.{item.title}
            </h3>
            <p>{item.description}</p>
          </div>
        ))}
        <p>Updated on: 03/05/2024</p>
      </div>
    </>
  );
}
